
define("vendors", function(){});
